import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Auth2Service } from '~app/shared/services/auth2/auth2.service';
import { StoreService } from '~app/shared/services/store/store.service';

@Injectable({
  providedIn: 'root',
})
export class Auth2Guard {
  constructor(
    private readonly auth: Auth2Service,
    private readonly router: Router,
    private readonly store: StoreService,
  ) {}
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (route.fragment) {
      this.store.currentUser = this.auth.authenticate(route.fragment);
      const parsedUrl = state.url.substring(0, state.url.indexOf('#'));
      this.router.navigateByUrl(parsedUrl, {
        replaceUrl: true,
      });
      return false;
    }

    let currentUser = this.store.currentUser;
    if (!currentUser) {
      const token = this.auth.getTokenFromLocalStorage();
      if (token) {
        currentUser = this.auth.authenticate(token);
        this.store.currentUser = currentUser;
      }
    }

    if (currentUser && currentUser.isSessionValid) {
      return true;
    } else {
      this.auth.redirectToLogin();
      return false;
    }
  }
}
